import { defineMessages } from "react-intl";

export default defineMessages({
  "issue.level.Error": {
    id: "issue.level.Error",
    defaultMessage: "Error",
  },
  "issue.level.Warning": {
    id: "issue.level.Warning",
    defaultMessage: "Warning",
  },
  "issue.level.Notification": {
    id: "issue.level.Notification",
    defaultMessage: "Notification",
  },
  "issue.level.Unexpected-value": {
    id: "issue.level.Unexpected-value",
    defaultMessage: "Unexpected value",
  },
  "missing.required.value": {
    id: "missing.required.value",
    defaultMessage: "Missing required value.",
  },
  "file.reference.not.found": {
    id: "file.reference.not.found",
    defaultMessage: "Reference to file ''{Filename}'' was not found.",
  },
  "residence.category.not.found": {
    id: "residence.category.not.found",
    defaultMessage: "Residence category with name ''{Name}'' not found.",
  },
  "residence.type.not.found": {
    id: "residence.type.not.found",
    defaultMessage: "Residence type with name ''{Name}'' not found.",
  },
  "roof.type.not.found": {
    id: "roof.type.not.found",
    defaultMessage: "Roof type with name ''{Name}'' not found.",
  },
  "energy.label.not.found": {
    id: "energy.label.not.found",
    defaultMessage: "Energy label with name ''{Name}'' not found.",
  },
  "deregistration.method.not.found": {
    id: "deregistration.method.not.found",
    defaultMessage: "Deregistration method with name ''{Name}'' not found.",
  },
  "facade.insulation.measure.not.found": {
    id: "facade.insulation.measure.not.found",
    defaultMessage: "Facade insulation measure with name ''{Name}'' not found.",
  },
  "panel.infill.situation.not.found": {
    id: "panel.infill.situation.not.found",
    defaultMessage: "Panel infill situation with name ''{Name}'' not found.",
  },
  "panel.infill.measure.not.found": {
    id: "panel.infill.measure.not.found",
    defaultMessage: "Panel infill measure with name ''{Name}'' not found.",
  },
  "glazing.situation.not.found": {
    id: "glazing.situation.not.found",
    defaultMessage: "Glazing situation with name ''{Name}'' not found.",
  },
  "glazing.measure.not.found": {
    id: "glazing.measure.not.found",
    defaultMessage: "Glazing measure with name ''{Name}'' not found.",
  },
  "frame.measure.not.found": {
    id: "frame.measure.not.found",
    defaultMessage: "Frame measure with name ''{Name}'' not found.",
  },
  "exterior.door.measure.not.found": {
    id: "exterior.door.measure.not.found",
    defaultMessage: "Exterior door measure with name ''{Name}'' not found.",
  },
  "floor.insulation.situation.not.found": {
    id: "floor.insulation.situation.not.found",
    defaultMessage:
      "Floor insulation situation with name ''{Name}'' not found.",
  },
  "floor.insulation.measure.not.found": {
    id: "floor.insulation.measure.not.found",
    defaultMessage: "Floor insulation measure with name ''{Name}'' not found.",
  },
  "roof.insulation.situation.not.found": {
    id: "roof.insulation.situation.not.found",
    defaultMessage: "Roof insulation situation with name ''{Name}'' not found.",
  },
  "roof.insulation.measure.not.found": {
    id: "roof.insulation.measure.not.found",
    defaultMessage: "Roof insulation measure with name ''{Name}'' not found.",
  },
  "ventilation.system.not.found": {
    id: "ventilation.system.not.found",
    defaultMessage: "Ventilation system with name ''{Name}'' not found.",
  },
  "central.heating.source.not.found": {
    id: "central.heating.source.not.found",
    defaultMessage: "Central heating source with name ''{Name}'' not found.",
  },
  "central.heating.supply.temperature.not.found": {
    id: "central.heating.supply.temperature.not.found",
    defaultMessage:
      "Central heating supply temperature with name ''{Name}'' not found.",
  },
  "tap.water.heating.source.not.found": {
    id: "tap.water.heating.source.not.found",
    defaultMessage: "Tap water heating source with name ''{Name}'' not found.",
  },
  "energy.performance.fee.category.not.found": {
    id: "energy.performance.fee.category.not.found",
    defaultMessage:
      "Energy performance fee category with name ''{Name}'' not found.",
  },
  "orientation.not.found": {
    id: "orientation.not.found",
    defaultMessage: "Orientation with name ''{Name}'' not found.",
  },
  "relative.position.not.found": {
    id: "relative.position.not.found",
    defaultMessage: "Relative position with name ''{Name}'' not found.",
  },
  "facade.insulation.situation.not.found": {
    id: "facade.insulation.situation.not.found",
    defaultMessage:
      "Facade insulation situation with name ''{Name}'' not found.",
  },
  "sheet.not.found": {
    id: "sheet.not.found",
    defaultMessage: "Sheet ''{SheetName}'' not found.",
  },
  "column.not.found": {
    id: "column.not.found",
    defaultMessage: "Column ''{ColumnName}'' not found.",
  },
  "column.not.found.on.sheet": {
    id: "column.not.found.on.sheet",
    defaultMessage: "Column ''{ColumnName}'' not found on sheet.",
  },
  "column.missing": {
    id: "column.missing",
    defaultMessage: "Missing column ''{ColumnName}'' on sheet ''{SheetName}''.",
  },
  "cell.value.not.found.on.sheet": {
    id: "cell.value.not.found.on.sheet",
    defaultMessage:
      "Missing cell value for required column ''{ColumnName}'' on sheet ''{SheetName}''.",
  },
  "cell.value.not.booleanish": {
    id: "cell.value.not.booleanish",
    defaultMessage:
      "Must be ''{YesValue}'' or ''{NoValue}'' (case insensitive).",
  },
  "file.not.found": {
    id: "file.not.found",
    defaultMessage: "File ''{Filename}'' was not found.",
  },
  "file.invalid.content.type": {
    id: "file.invalid.content.type",
    defaultMessage:
      "File ''{Filename}'' has an invalid content type: ''{ContentType}''.",
  },
  "duplicate.columns.found": {
    id: "duplicate.columns.found",
    defaultMessage: "Duplicate column(s) found for {ColumnName}.",
  },
  "cell.validation.failed": {
    id: "cell.validation.failed",
    defaultMessage:
      "Cell under column ''{ColumnName}'' on sheet ''{SheetName}'' at row number ''{RowNumber}'' failed validation.",
  },
  "sheet.duplicate": {
    id: "sheet.duplicate",
    defaultMessage: "Sheet ''{SheetName}'' exists multiple times.",
  },
  "column.missing.on.sheet": {
    id: "column.missing.on.sheet",
    defaultMessage:
      "Expected column ''{ColumnName}'' is missing from sheet ''{SheetName}''.",
  },
  "sheet.missing": {
    id: "sheet.missing",
    defaultMessage: "Expected sheet ''{SheetName}'' is missing.",
  },
  "compactness.invalid": {
    id: "compactness.invalid",
    defaultMessage: "Compactness must be greater than or equal to 1.",
  },
  "usable.area.larger.than.loss.area": {
    id: "usable.area.larger.than.loss.area",
    defaultMessage: "Usable area is larger than loss area.",
  },
  "bag.registration.number.invalid": {
    id: "bag.registration.number.invalid",
    defaultMessage: "BAG registration number is invalid.",
  },
  "referenced.data.not.found.on.sheet": {
    id: "referenced.data.not.found.on.sheet",
    defaultMessage:
      "Referenced data not found on the ''{ReferencedSheetName}'' sheet.",
  },
  "duplicate.scenario-names.found": {
    id: "duplicate.scenario-names.found",
    defaultMessage:
      "Duplicate scenario names found for the ''{ResidenceTypeName}'' residence type.",
  },
  "facade.insulation.thermal.resistance.missing": {
    id: "facade.insulation.thermal.resistance.missing",
    defaultMessage: "Facade insulation thermal resistance is missing.",
  },
  "flat.roof.insulation.thermal.resistance.missing": {
    id: "flat.roof.insulation.thermal.resistance.missing",
    defaultMessage: "Flat roof insulation thermal resistance is missing.",
  },
  "floor.insulation.thermal.resistance.missing": {
    id: "floor.insulation.thermal.resistance.missing",
    defaultMessage: "Floor insulation thermal resistance is missing.",
  },
  "gable.end.insulation.thermal.resistance.missing": {
    id: "gable.end.insulation.thermal.resistance.missing",
    defaultMessage: "Gable end insulation thermal resistance is missing.",
  },
  "panel.infill.thermal.resistance.missing": {
    id: "panel.infill.thermal.resistance.missing",
    defaultMessage: "Panel infill thermal resistance is missing.",
  },
  "required.gable.end.insulation.for.corner.house.missing": {
    id: "required.gable.end.insulation.for.corner.house.missing",
    defaultMessage:
      "Required gable end insulation for corner house is missing.",
  },
  "airtightness.greaterOrEqualTo.zero": {
    id: "airtightness.greaterOrEqualTo.zero",
    defaultMessage: "Airtightness must be greater than or equal to 0.",
  },
  "scenario.no.situations": {
    id: "scenario.no.situations",
    defaultMessage:
      "No situations found for residence type ''{ResidenceTypeName}''.",
  },
  "not.allowed.for.current.situation.scenarios": {
    id: "not.allowed.for.current.situation.scenarios",
    defaultMessage:
      "Not allowed for current situation-scenarios because it is only used for measures.",
  },
  "entity.not.found": {
    id: "entity.not.found",
    defaultMessage: "Entity of type {EntityTypeName} not found.",
  },
  "row.index.not.found": {
    id: "row.index.not.found",
    defaultMessage: "Row at index {RowIndex} not found.",
  },
  "row.index.missing": {
    id: "row.index.missing",
    defaultMessage: "Row index missing.",
  },
  "property.name.missing": {
    id: "property.name.missing",
    defaultMessage: "Property name missing.",
  },
  "column.index.not.inferrable": {
    id: "column.index.not.inferrable",
    defaultMessage:
      "Column index could not be determined from property ''{PropertyName}''.",
  },
  "cell.value.not.convertible": {
    id: "cell.value.not.convertible",
    defaultMessage:
      "Cell value ''{Value}'' for column ''{ColumnName}'' on sheet ''{SheetName}'' could not be converted to {TargetType}.",
  },
  "custom.data.mapping.failed": {
    id: "custom.data.mapping.failed",
    defaultMessage:
      "Custom data mapping failed for column ''{ColumnName}'' on sheet ''{SheetName}''.",
  },
});